<script>
    import DesktopButton2 from '../../reusableitems/DesktopButton2.svelte';
</script>

<section>
    <div class="main-div">
        <div class="images-div">
            <div class="mobile-div">
                <img
                    src="images/Perfomance/Group10000025751.png"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="back-div">
                <img
                    src="images/Perfomance/back4.svg"
                    alt=""
                    width="100%"
                    height="100%"
                />
            </div>
            <div class="Number">
                <p>4</p>
            </div>
            <div class="text-div">
                <p>Performers & Opus</p>
                <p>Choreography</p>
                <p>
                    Choreography is as old as the human subspecies itself. It’s
                    part of our genetic composition and something that enthralls
                    us all alike.
                </p>
                <p>
                    Our <span ><u>motion recording app</u></span> turns a simple smartphone into a
                    performance capture studio without any specialized
                    equipment. Become part of the future of democratized
                    entertainment in the making.
                </p>
                <div class="btn-div">
                    <DesktopButton2
                        state = "Performer"
                        width="24.074vh"
                        text1 = "Join Artist Governance Council"
                        text2="(Choreographer Seat)"
                        AnimationColor="black"
                        TextColorAfter="#67eebb"
                        BorderColorAfter="black"
                        text3="15"
                    />
                </div>
            </div>
            
        </div>
        <div class="scroll_div">
            <svg
            width="6.185vh"
            height="0.741vh"
            viewBox="0 0 72 8"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            class="img"
        >
            <path
                d="M71.3536 4.35355C71.5488 4.15829 71.5488 3.84171 71.3536 3.64645L68.1716 0.464466C67.9763 0.269204 67.6597 0.269204 67.4645 0.464466C67.2692 0.659728 67.2692 0.976311 67.4645 1.17157L70.2929 4L67.4645 6.82843C67.2692 7.02369 67.2692 7.34027 67.4645 7.53553C67.6597 7.7308 67.9763 7.7308 68.1716 7.53553L71.3536 4.35355ZM0 4.5H71V3.5H0V4.5Z"
            />
        </svg>
            <p class="scrollText" >scroll / drag</p>
           
        </div>
    </div>
</section>

<style>
    .main-div {
        width: 121.389vh;
        height: 100vh;
        overflow: hidden;
        padding-right: 9vh;
        position: relative;
    }
    .images-div {
        display: flex;
        position: relative;
    }
    .back-div {
        position: absolute;
        left: 29.63vh;
        width: 86.111vh;
        height: 100vh;
        pointer-events:none ;
        z-index: -1;
    }
    .Number{
        position: absolute;
        top: -6.229vh;
        left: 38.3vh;
    }
    .Number p{
        margin: 0;
        font-weight: 700;
        font-size: 27.778vh;
        line-height: 27.778vh;
        color: rgba(255, 255, 255, 0.6);
        font-family: 'Orbitron';
    }
    .mobile-div {
        right: 24vh;
        position: absolute;
        top: -1.8vh;
        transform: scale(1.05);
        width: 134.63vh;
        pointer-events: none;
    }
    .text-div {
        position: absolute;
        right: 14.63vh;
        width: 64.537vh;
        font-family: "Orbitron";
        top: 22.963vh;
    }
    .text-div p:nth-child(1) {
        font-size: 1.296vh;
        letter-spacing: 0.058vh;
        font-weight: 400;
        text-transform: uppercase;
        margin-left: 24vh;
    }
    .text-div p:nth-child(2) {
        font-size: 5.556vh;
        line-height: 5.556vh;
        margin-top: 1.111vh;
        margin-bottom: 6.667vh;
        letter-spacing: 0.058vh;
        font-weight: 700;
        margin-left: 24vh;
        text-transform: uppercase;
    }
    .text-div p:nth-child(3) {
        margin-top: 5.833vh;
        font-size: 1.852vh;
        line-height: 2.593vh;
        letter-spacing: 0.058vh;
        margin-left: 28vh;
        width: 35.278vh;
        font-weight: 400;
    }
    .text-div p:nth-child(4) {
        margin-top: 14.148vh;
        margin-left: 12vh;
        font-size: 1.852vh;
        line-height: 2.593vh;
        letter-spacing: 0.058vh;
        width: 49.63vh;
        font-weight: 400;
    }
    span{
        color: #1C7BFF;
        font-weight: 700;
    }
    .btn-div {
        margin-top: 4.167vh;
        margin-left: 12vh;
    }
    .scroll_div {
        display: flex;
        align-items: center;
        position: absolute;
        bottom: 2.5vh;
        left: 0vh;
    }
    .scroll_div .scrollText {
        font-size: 1.481vh;
        font-weight: 500;
        line-height: 1.857vh;
        font-family: "Orbitron";
        color: black;
        text-transform: capitalize;
    }
    .scroll_div .img {
        margin-right: 1.778vh;
        width: 6.185vh;
        height: 0.741vh;
        fill: black;
        transform: rotate(180deg);
}
</style>
